var config = require('./../config/base.config').Config;
module.exports = {
  Config: config,
};



// WEBPACK FOOTER //
// ./config/app.config.js